<template>
  
  <div>
    <HeadNav_M v-if="plates.length>0&&webConfigs&&global.isPhone()&&($route.path.indexOf('inqCertM')>-1||$route.path.indexOf('certResult')>-1||$route.path.indexOf('infoQuery')>-1)" :webConfigs="webConfigs" :plates="plates" :key="Math.random()"> </HeadNav_M>
    <HeadNav v-else-if="plates.length>0&&webConfigs" :webConfigs="webConfigs" :plates="plates" :key="Math.random()"> </HeadNav>
    <router-view v-if="plates.length>0&&webConfigs" :webConfigs="webConfigs" :plates="plates" @onLineMsg="dialogFormVisible=true"  :key="Math.random()"></router-view>
    <foot-info v-if="plates.length>0&&webConfigs" :webConfigs="webConfigs" :plates="plates"/>
  </div>
</template>

<script>
import HeadNav from "../components/PublicComs/HeadNav";
import global from "@/components/PublicComs/Common.vue";
import { Message } from "element-ui";
import FootInfo from "../components/HomeComs/FootInfo.vue";
import HeadNav_M from '../components/PublicComs/HeadNav_M.vue';
const rate= window.innerWidth/1240;
export default {
  metaInfo: {
    title: '信息查询',
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  name: "index",
  components: {
    HeadNav,
    FootInfo,
    HeadNav_M,
  },
  data() {
    return {
      global,
      plates: [],
      webConfigs: null,
      form: {
        name: "",
        content: "",
        phone: "",
        yzmsrc: "",
        yzcode: "",
      },
    };
  },
  mounted() {
    this.$axios.get("/api/webConfigs").then((res) => {
      if (res.data) {
        this.webConfigs = res.data.data[0];
      }
    });
    this.$axios
      .get("/api/categorys?page=1&limit=30&firstView=1")
      .then((res) => {
        if (res.data) {
          this.$nextTick(function() {
            this.plates = res.data.data;
          });
        }
      });
    $("html").addClass("no-fouc");
    document.addEventListener("touchstart", function(event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function(event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {},
  watch: {},
};
</script>
<style scoped>
</style>
